module.exports = __webpack_public_path__ + "static/media/shipping-truck-2.d531b3af.svg";